import { render } from "./Welcome.vue?vue&type=template&id=09c8f0aa&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=ts"
export * from "./Welcome.vue?vue&type=script&lang=ts"

import "./Welcome.vue?vue&type=style&index=0&id=09c8f0aa&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-09c8f0aa"

export default script